import { HttpClient, provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http'; // Add HttpClientModule
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard, MsalInterceptor, MsalModule, MsalService } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FloatProfileBarComponent } from '../app/common/components/float-profile-bar/float-profile-bar.component';
import { ActiveHotCallsComponent } from './active-hot-calls/component/active-hot-calls.component';
import { AppComponent } from './app.component';
import { ClosedHotCallsComponent } from './closed-hot-calls/component/closed-hot-calls.component';
import { FooterComponent } from './common/components/footer/footer.component';
import { HeaderComponent } from './common/components/header/home/header.component';
import { SubmitDialogeComponent } from './common/components/submit-dialoge/submit-dialoge.component';
import { BarcodeScannerComponent } from './create-new-hot-call/barcode-scanner/barcode-scanner.component';
import { CreateHotCallFormComponent } from './create-new-hot-call/create-hot-call-form/create-hot-call-form.component';
import { CreateNewHotCallComponent } from './create-new-hot-call/create-new-hot-call.component';
import { ScannerComponent } from './create-new-hot-call/scanner/scanner.component';
import { UpdateRunoutInformationComponent } from './create-new-hot-call/update-runout-information/update-runout-information.component';
import { CustomErrorHandler } from './errorhandler.provider';
import { HomeComponent } from './home/component/home.component';
import { LoggerService } from './logger.service';
import { LoginPreferenceComponent } from './login/login-preference/login-preference.component';
import { LoginComponent } from './login/login/login.component';
import { ManageProfileComponent } from './manage-profile/components/manage-profile.component';
import { ViewProfileComponent } from './manage-profile/view-profile/components/view-profile.component';
import { MyHotCallsComponent } from './my-hot-calls/component/my-hot-calls.component';
import { environment } from 'src/environments/environment';
import { SpinnerComponent } from './common/components/spinner/spinner.component';
import { SpinnerService } from './common/services/spinner.service';
import { pieAuthInterceptor } from '../app/common/pie-auth.interceptor';
import { ErrorHandlerComponent } from './common/components/error-handler/error-handler.component';
import { ScrollingModule } from '@angular/cdk/scrolling';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const routes: Routes = [
  // { path: '', redirectTo: 'save-user-profile', pathMatch: 'full' },
  { path: 'home', component: HomeComponent, canActivate: [MsalGuard] },
  { path: 'active-hot-calls', component: ActiveHotCallsComponent, canActivate: [MsalGuard] },
  { path: 'closed-hot-calls', component: ClosedHotCallsComponent, canActivate: [MsalGuard] },
  { path: 'my-hot-calls', component: MyHotCallsComponent, canActivate: [MsalGuard] },
  { path: 'manage-profile', component: ManageProfileComponent, canActivate: [MsalGuard] },
  { path: 'create-hot-call', component: CreateNewHotCallComponent, canActivate: [MsalGuard] },
  { path: 'edit-profile', component: LoginPreferenceComponent, canActivate: [MsalGuard] },
  { path: 'view-profile', component: ViewProfileComponent, canActivate: [MsalGuard] },
  { path: 'save-user-profile', component: LoginPreferenceComponent, canActivate: [MsalGuard] },
  { path: 'scanner', component: ScannerComponent },
  {path: '', component: LoginComponent }
];


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    ActiveHotCallsComponent,
    MyHotCallsComponent,
    ClosedHotCallsComponent,
    FooterComponent,
    HomeComponent,
    ManageProfileComponent,
    ViewProfileComponent,
    SubmitDialogeComponent,
    CreateNewHotCallComponent,
    CreateHotCallFormComponent,
    LoginPreferenceComponent,
    ViewProfileComponent,
    UpdateRunoutInformationComponent,
    FloatProfileBarComponent,
    BarcodeScannerComponent,
    ScannerComponent,
    LoginComponent,
    SpinnerComponent,
    ErrorHandlerComponent
  ],

  imports: [
    BrowserModule,
    MatButtonModule,
    TranslateModule,
    MatExpansionModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    MatCardModule,
    ReactiveFormsModule,
    MatStepperModule,
    MatRadioModule,
    MatProgressSpinner,
    MatDialogModule,
    MatToolbarModule,
    MatIconModule,
    FormsModule,
    MatOptionModule,
    ReactiveFormsModule,
    MatTooltipModule,
    ScrollingModule,
    RouterModule.forRoot(routes),
    MsalModule.forRoot(new PublicClientApplication({
      auth: {
        clientId: '8f4c6f77-a378-4939-8557-c40a9ebe15ef',
        authority: 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef',
        redirectUri: environment.ssoredirectUri
      }
    }), {
      interactionType: InteractionType.Redirect,
      authRequest: {
        scopes: ['user.read']
      }
    }, {
      interactionType: InteractionType.Redirect,
      protectedResourceMap: new Map([
        ['https://graph.microsoft.com/v1.0/me', ['user.read']]
      ])
    }),
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],

  providers: [LoggerService, provideHttpClient(), { provide: ErrorHandler, useClass: CustomErrorHandler ,
    deps: [LoggerService] }, provideAnimationsAsync(),
    MsalService, MsalGuard, MsalInterceptor,
		provideHttpClient(withInterceptorsFromDi()), SpinnerService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: pieAuthInterceptor,
      multi: true
    }],
  bootstrap: [AppComponent]
})
export class AppModule { }